import { Grid, Cell } from 'components/Grid';
import styles from './sectionOverviews.scss';
import { connect } from 'react-redux';
import { isMobile, isHuge } from 'components/Shared/responsive';
import { SectionOverview as SectionOverviewModel } from 'models/SectionOverview';
import { HeaderState } from 'models/HeaderState';
import { NO_ELEMENT } from 'utils';
import { CategoryLink } from 'components/Shared/CategoryLink';
import { Section } from 'components/Section';
import cn from 'classnames';

interface ConnectedProps {
  isMobile: boolean;
  isHuge: boolean;
  shouldUseWideImage?: boolean;
}

interface MergedProps extends ConnectedProps {
  sections: SectionOverviewModel[];
  title: string;
}

const _SectionOverviews = ({ isMobile, isHuge, sections, title }: MergedProps) => {
  if (!sections) {
    return NO_ELEMENT;
  }

  const content = sections
    .filter(({ title }) => title !== 'Outlet')
    .map(({ title, url, categoryImage }) => (
      <Cell key={url}>
        <CategoryLink
          appearance={isMobile ? 'tertiary' : 'primary'}
          title={title}
          categoryUrl={url}
          image={categoryImage}
        />
      </Cell>
    ));

  return (
    <Section title={<h1>{title}</h1>} className={styles.section}>
      <Grid
        className={cn({ [styles.center]: isHuge })}
        gutters={isHuge ? 'extraLarge' : isMobile ? 'small' : 'medium'}
        huge="8"
        desktop="6"
        large="5"
        tablet="4"
        phone="3"
      >
        {content}
      </Grid>
    </Section>
  );
};

export const SectionOverviews = connect<ConnectedProps>(
  ({ currentBreakpoint }: HeaderState): ConnectedProps => ({
    isMobile: isMobile({ currentBreakpoint }),
    isHuge: isHuge({ currentBreakpoint })
  })
)(_SectionOverviews);
